import axios from 'axios';
import config from './config';

class account {
    constructor() {
        this.url = config.url();
    }

    async login(email,pwd){
        try{
            var data = { "email":email,"pwd":pwd };
            var result = await axios.post(this.url + "/api/account/login",data,{ responseType:'json',credentials:false});
            sessionStorage.setItem("vtoken",result.data.data[0].vtoken);
            sessionStorage.setItem("vkey",result.data.data[0].vkey);
            return (result.status==200) ? result.data : {code:-2,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }

    async logout(){
        try{
            var data = { };
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/account/logout",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }

    async info(){
        try{
            var data = { };
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/account/info",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }

    async update(account){
        try{
            var data = account;
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/account/update",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }

    async pwd_init(email){
        try{
            var data = { "email":email};
            var pkgheaders = {};
            var result = await axios.post(this.url + "/api/account/pwd/init",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }

    async pwd_init_validate(code,email,pwd){
        try{
            var data = { code:code,email:email,pwd:pwd };
            var pkgheaders = {};
            var result = await axios.post(this.url + "/api/account/pwd/init/validate",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }
}

export default new account()